'use client'

import { SearchForm } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { useProductReviewFilters } from '../../../../../lib/hooks/useProductReviewFilters'

export const SearchReviewInput = () => {
  const fixtures = useTranslation().magnolia.reviewsPage
  const { filters, updateFilters } = useProductReviewFilters()

  return (
    <SearchForm
      initialValue={filters.search ?? ''}
      placeholderLabel={fixtures.search}
      onSubmit={search => updateFilters({ ...filters, search: search ?? undefined })}
    />
  )
}
